import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import gwdgLogo from 'assets/svg/gwdg_logo.min.svg';

import Img from 'components/Img';

import messages from './messages';

const GWDGLogo = ({ logoUrl, imageAlt, ...cssProps }) => {
  const { formatMessage } = useIntl();

  return (
    <Img
      {...cssProps}
      height={42}
      maxHeight={50}
      maxWidth={200}
      src={logoUrl ?? gwdgLogo}
      alt={imageAlt ?? formatMessage(messages.defaultMSULogoAlt)}
    />
  );
};

GWDGLogo.propTypes = {
  logoUrl: PropTypes.string,
  imageAlt: PropTypes.string,
};

export default memo(GWDGLogo);
